import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { AlertConfig } from '../../services/interceptor/interceptor.service';

@Component({
  selector: 'app-alert-interceptor',
  templateUrl: './alert-interceptor.component.html',
  styleUrls: ['./alert-interceptor.component.scss'],
  standalone: true,
  imports: [
    ButtonComponent,
    CommonModule,
  ],
})
export class AlertInterceptorComponent {
  protected config: AlertConfig | null = null;
  protected isClosing = false;
  protected isVisible = false;

  open(config: AlertConfig): void {
    if (this.isVisible) {
      return;
    }
    this.config = config;
    this.isVisible = true;
  }

  protected click(): void {
    if (!this.config) {
      return;
    }
    this.isClosing = true;
    setTimeout(() => {
      this.isVisible = false;
      this.isClosing = false;
      if (this.config?.action) {
        this.config.action();
      }
      this.config = null;
    }, 300);
  }

  protected close(): void {
    this.isClosing = true;
    setTimeout(() => {
      this.isVisible = false;
      this.isClosing = false;
      this.config = null;
    }, 300);
  }
}